import ReactOnRails from "react-on-rails";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locale/en.json";
import sv from "../locale/sv.json";

import Footer from "app/bundles/Footer/components";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: en,
        },
        sv: {
            translation: sv,
        },
    },
    lng: "sv",
    fallbackLng: "en",

    interpolation: {
        escapeValue: false,
    },
});

// This is how react_on_rails can see the components in the browser.
ReactOnRails.register({
    Footer,
});
